import { Component } from '@angular/core';
import { NavParams, ViewController, LoadingController } from 'ionic-angular';
import { SubscriptionsService } from '../../services/subscriptions/subscriptions-service';
import { ENV } from '../../environments/environment';

@IonicPage()
@Component({
  selector: 'page-qr-generator-modal',
  templateUrl: 'qr-generator-modal.html',
})
export class QrGeneratorModalPage {
  public qrCodeGenerated: boolean = false;
  private hash: string;
  private qrCodeFilename: string;

  generate() {
    let self: QrGeneratorModalPage = this;
    let loading = this.loadingCtrl.create({
      content: 'Generating...'
    });

    loading.present();

    this.subscriptionService.regenerate(this.navParams.get("contact_id"), this.navParams.get("hash"))
      .subscribe(res => {
        this.qrCodeFilename = [
          self.navParams.get("contact_id"),
          self.navParams.get("subscription_id"),
          res,
          "svg"
        ].join(".");
        loading.dismiss();
        self.hash = res;
        self.qrCodeGenerated = true;
      });
  }

  print() {
    let self: QrGeneratorModalPage = this;
    let qrDom: string;
    qrDom = "<html style='margin:0px;padding:0px;border:thin solid transparent;width:210px;height:190px;overflow:hidden;'>"
          +   "<head></head>"
          +   "<body style='padding-left:50px;'>"
          +     "<div style='margin:0px;margin-top:-20px;padding:0px;border:thin solid transparent;overflow:hidden;width:210px;height:190px;'>"
          +       `<img src='${ENV.apiUrl}/qr-codes/${this.qrCodeFilename.replace(".svg",".md.svg")}' `
          +       "style='width:180px;height:180px;margin:0px;margin-left:-10px;margin-top:-10px;padding:0px;border:thin solid transparent;' />"
          +     "</div>"
          +   "</body>"
          +  "</html>";

    var printWindow = window.open('', 'Family Car Wash | Subscription QR Code','height=300,width=300');
    printWindow.document.write(qrDom);
    printWindow.document.close();
    printWindow.onload = function() {
      printWindow.print();
      self.close();
    };
  }

  close() {
    this.viewCtrl.dismiss({hash: this.hash && this.hash != null ? this.hash : false});
  }

  constructor(private navParams: NavParams,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private subscriptionService: SubscriptionsService) {
      this.qrCodeGenerated = false;
    }
}



// WEBPACK FOOTER //
// ./src/pages/qr-generator-modal/qr-generator-modal.ts